var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8CalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2A60BC;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-calendar",
    className: "cls-1",
    d: "M8.889,6A2.9,2.9,0,0,0,6,8.889V19.111A2.9,2.9,0,0,0,8.889,22H19.111A2.9,2.9,0,0,0,22,19.111V8.889A2.9,2.9,0,0,0,19.111,6Zm0,1.333H19.111a1.546,1.546,0,0,1,1.556,1.556v.667H7.333V8.889A1.546,1.546,0,0,1,8.889,7.333ZM7.333,10.889H20.667v8.222a1.546,1.546,0,0,1-1.556,1.556H8.889a1.546,1.546,0,0,1-1.556-1.556Zm2.889,1.778a1.111,1.111,0,1,0,1.111,1.111,1.111,1.111,0,0,0-1.111-1.111Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,14,12.667Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,17.778,12.667Zm-7.556,4a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,10.222,16.667Zm3.778,0a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,14,16.667Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CalendarBlue);
export default __webpack_public_path__ + "static/media/icons8-calendar-blue.4f72433a8b9e86117ae4e3a9db434eb2.svg";
export { ForwardRef as ReactComponent };